/**
 * Groups for Dashboard
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import Search from 'components/interaction/Search/index.jsx';
import useMemoryState from 'utils/useMemoryState.js';
import useHashTabs from 'utils/useHashTabs.js';
import GroupType from './GroupType.jsx';
import ArchiveType from './ArchiveType.jsx';
import EditModal from './GroupDetails/EditModal/index.jsx';
import messages from './messages.js';
import useGroupTypes from './useGroupTypes.js';

function Groups(props) {
  const { setMeta } = props;
  const types = useGroupTypes();
  const [searchText, setSearchText] = useMemoryState('adminGroupSearch', '');
  const [addType, setAddType] = useState(null);
  const newGroup = addType && {
    groupType: addType.key,
    typeName: addType.id,
  };
  const { typeId, toTab } = useHashTabs();
  const pageTabs = {
    base: '#',
    tabMessages: messages,
    active: typeId,
    options: types.filter((t) => !t.noTab),
  };
  const handleSearchChange = (term) => {
    setSearchText(term);
  };
  const search = <Search value={searchText} onChange={handleSearchChange} className="mb-2" />;
  const currentType = types.find((opt) => opt.id === typeId);
  useEffect(() => {
    setMeta({
      title: [messages.groups, messages[typeId]],
      pageTitle: messages.groups,
      pageTabs,
      search,
    });
    if (!typeId || !currentType) {
      toTab(types[0].id);
    }
  }, [typeId, currentType]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!typeId || !currentType) {
    return null;
  }
  const { addLabel } = currentType;
  const addControl = addLabel && <Button variant="light" onClick={() => setAddType(currentType)}><FormattedMessage {...addLabel} /></Button>;
  return (
    <>
      {typeId === 'archive'
        ? <ArchiveType intro={currentType.intro} search={searchText} />
        : <GroupType type={currentType} search={searchText} control={addControl} />}
      <EditModal show={Boolean(addType)} title={addLabel} group={newGroup} onHide={() => setAddType(null)} />
    </>
  );
}

Groups.propTypes = {
  setMeta: PropTypes.func,
};

export default Groups;
